import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useRequestMagicLink } from '../../api/hooks/auth.hook';
import { useAuth } from '../../auth/AuthProvider';
import { Button } from '../../components/common/Button';

export const SignUpPage = () => {
  const navigate = useNavigate();
  const { status } = useAuth();
  const [email, setEmail] = useState('');
  const requestLink = useRequestMagicLink();
  const [submittedEmail, setSubmittedEmail] = useState<string | null>(null);

  useEffect(() => {
    if (status === 'authenticated') {
      navigate('/knowledge');
    }
  }, [navigate, status]);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setSubmittedEmail(email);
    try {
      await requestLink.mutateAsync({ email });
    } catch (submitError) {
      console.error(submitError);
      setSubmittedEmail(null);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <h1 className="auth-title">Request access to insora</h1>
          <p className="auth-subtitle">Enter your work email and we’ll send a magic link.</p>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Work email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              required
              disabled={requestLink.isLoading}
            />
          </div>

          {requestLink.isError && (
            <div className="p-3 mb-3 rounded bg-red-50 text-red-700 text-sm border border-red-200">
              Unable to send a magic link. Please verify the email and try again.
            </div>
          )}

          {requestLink.isSuccess && submittedEmail && (
            <div className="p-3 mb-3 rounded bg-green-50 text-green-700 text-sm border border-green-200">
              We sent a sign-in link to <strong>{submittedEmail}</strong>. Use it to finish setting
              up your account.
              {requestLink.data.token && (
                <>
                  <br />
                  <span className="text-xs text-green-800">
                    Dev token: {requestLink.data.token}
                  </span>
                </>
              )}
            </div>
          )}

          <Button
            text={requestLink.isLoading ? 'Sending link…' : 'Send magic link'}
            type="submit"
            disabled={requestLink.isLoading}
            className="auth-submit-btn"
          />

          <div className="auth-footer">
            <p>
              Already have a link?{' '}
              <a href="/signin" className="auth-link">
                Sign in
              </a>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignUpPage;
